import { Component, OnInit, OnDestroy } from '@angular/core';
import { LazyLoadScriptService } from './../sidebar/lazy-load-script.service'
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'app-leads',
  templateUrl: './leads.component.html',
  styleUrls: ['./leads.component.css']
})
export class LeadsComponent implements OnInit {
  imageoneLead: boolean = false;
  pageTitle: string;
  pageDisplay: string;

  constructor(private activatedroute: ActivatedRoute,
    private router: Router, private lazyLoadService: LazyLoadScriptService) { }

  ngOnInit(): void {
    var applicationName = "leadappappelement";
    this.lazyLoadService.loadScript(environment["LEADAPPURL"], applicationName).subscribe(_ => {
      let url = this.router.url;
      if (url == '/lead/newlead') {
        this.pageTitle = "New Lead";
        this.pageDisplay = "leadAdd";
      } else if (url == '/lead/openlead') {
        this.pageTitle = "Open Leads";
        this.pageDisplay = "openLead";
      } else if (url == '/lead/followups') {
        this.pageTitle = "Follow Ups";
        this.pageDisplay = "followups";
      } else if (url == '/lead/appointmentlist') {
        this.pageTitle = "Appointments List";
        this.pageDisplay = "appointmentList";
      } else if (url == '/lead/inactiveleads') {
        this.pageTitle = "Inactive Leads List";
        this.pageDisplay = "inactiveLeads";
      } else if (url == '/lead/reviewleads') {
        this.pageTitle = "Review Possible Duplicate Leads List";
        this.pageDisplay = "reviewLeads";
      } else if (url == '/lead/territory-search') {
        this.pageTitle = "Territory Search";
        this.pageDisplay = "territorySearch";
      } else if (url == '/lead/export') {
        this.pageTitle = "Export Leads";
        this.pageDisplay = "exportLeads";
      } else if (url == '/lead/manageleads') {
        this.pageTitle = "Manage Leads";
        this.pageDisplay = "manageLeads";
      } else if (url == '/lead/managefollowups') {
        this.pageTitle = "Manage Follow Ups";
        this.pageDisplay = "manageFollowUps";
      } else if (url.includes('/lead/edit')) {
        this.pageTitle = "Update Lead Information";
        this.pageDisplay = "leadEdit";
      } else if (url.includes('/lead/activityreports')) {
        this.pageTitle = "Activity Reports";
        this.pageDisplay = "activityReports";
      } else if (url.includes('/lead/appointmentrun')) {
        this.pageTitle = "Appointment Run list";
        this.pageDisplay = "appointmentRunList";
      } else if (url.includes('/lead/importleads')) {
        this.pageTitle = "Import Leads";
        this.pageDisplay = "importLeads";
      } else if (url.includes('/lead/cancelclientfollowup')) {
        this.pageTitle = "Cancelled Client Follow ups";
        this.pageDisplay = "cancelClientFollowUpLeads";
      } else if (url.includes('/lead/email-allowlist')) {
        this.pageTitle = "Email Allowlist";
        this.pageDisplay = "emailAllowlist";
      } else if (url.includes('/lead/processed-emails')) {
        this.pageTitle = "Processed Emails";
        this.pageDisplay = "processedEmails";
      }

      this.imageoneLead = true;
    });

  }

  ngOnDestroy(): void {

    this.imageoneLead = false;
  }


}
